import { createPageTableSchema } from '@state/_shared/tableComponentStateSchema';

const containerTypesRowSchema = {
    type: 'object',
    properties: {
        id: { type: ['number', 'string'], default: '' },
        name: { type: 'string', default: '' },
        container_length_cm: { type: ['number', 'string', 'null'], default: null },
        container_width_cm: { type: ['number', 'string', 'null'], default: null },
        container_height_cm: { type: ['number', 'string', 'null'], default: null },
        max_item_stud_length: { type: ['number', 'null'], default: null },
        min_volume: { type: ['number', 'string', 'null'], default: null }
    }
};

const containerTypesRowActions = {};

const pageTableSchema = createPageTableSchema(containerTypesRowSchema, containerTypesRowActions);

export const containerTypesPageStateSchema = {
    title: {
        type: 'string',
        default: 'Container Types'
    },
    table: pageTableSchema
};
